export default {
  userHasSentMessage: false,
  lastActiveTime: null,
  showFeedbackModal: false,
  organizationDetailsError: null,
  isPlanRequested: false,
  isChatReady: false,
  defaultMessages: [],
  readOnlyMode: false,
  messages: [],
  organizationDetails: null,
  slug: null,
  token: null,
  regenerateResponse: false,
  intent: null,
  quickReplies: [],
  isFetchingIntent: null,
  planRequested: false,
  isGridMode: true,
  isMayaResponding: false,
  isSocketConnectionEstablished: false,
  isExpectingAssistantResponse: false,
  isTestCase: false,
  quickSearches: null,
  searchResults: null,
  searchSlug: null,
  defaultSearchResults: true,
  searchQuery: '',
  searchAiTextResponse: ``,
  isFetchingSearchResults: false,
  isFetchingAiQueryResponse: false,
  aiSearchQueryToken: null,
  isInternalCase: false,
  isInternalCaseInQueryOrOptions: false,
  generateAiQueryResponse: true,
  brand: null,
}
